import React from 'react';
import GenericListPage from '../GenericListPage';
import AttributeForm from './AttributeForm';

const attributeColumns = [
  { header: 'ID', key: '_id', render: attr => attr._id.substring(0, 8) + '...' },
  { header: 'Name', key: 'name' },
];

const AttributesPage = () => (
  <GenericListPage
    title="Attributes"
    permission="manage_attributes"
    entityEndpoint="attributes"
    columns={attributeColumns}
    FormComponent={AttributeForm}
    filterConfig={[]} // Add filters if needed
  />
);

export default AttributesPage;